import React, { forwardRef, useEffect, useState} from "react";
import './SliderActivityHistory.scss';
import { Column, Row } from "../../../components";
import CustomerActivityService from "../../customer-activity/CustomerActivityService";
import { Button} from "react-bootstrap";


export interface ISliderActivityHistory {
    customerId?: string
}

export interface SliderActivityHistoryHandles {
    save: () => Promise<boolean>;
}

const SliderActivityHistoryInner: React.ForwardRefRenderFunction<SliderActivityHistoryHandles, ISliderActivityHistory> = (props) => {

    const customerActivityService = new CustomerActivityService();

    const [pageNumber, setPagenumber]= useState(1);
    const [pageSize, setPageSize]= useState(4);
    const [customerActivities, setCustomerActivities] = useState([]);
    const [expandedActivities, setExpandedActivities] = useState<{ [key: string]: boolean }>({});
    const [loadMoreButton, setLoadMoreButton] = useState(false);


    var dateOptions = { year: 'numeric', month: 'long', day: 'numeric' };
    var timeOptions = { hour: 'numeric', minute: 'numeric', hour12: true };
    var charLength = 30;

   const toggleExpanded = (activityId: string) => {
        setExpandedActivities(prev => ({
            ...prev,
            [activityId]: !prev[activityId]
        }));
    };

     const loadMoreActivities = () => {
        setPagenumber(prevPageNum => prevPageNum + 1); // Increment page
    };

     const fetchActivities = async () => {
            try {
                let customerActivity = await customerActivityService.getActivites(props.customerId, pageNumber,null,pageSize);
                let custActivities = customerActivity.data;
                
                if (customerActivity.status == 206 || (customerActivity.data.length >=pageSize)) {
                    setLoadMoreButton(true);
                }
                else {
                    setLoadMoreButton(false);
                }
                if (pageNumber === 1) {
                    setCustomerActivities(custActivities);
                }
                else {
                    setCustomerActivities(prevData => [...prevData, ...custActivities]);
                }
            }
            catch (ex) {
               
            }
        };
    
        useEffect(() => {
            fetchActivities();
        }, [pageNumber]);
    


    const mainContennt = <>
        <Row>
            <Column lg={12} md={12} className="">
                <h6 className="sld-act-section-header">Activity History</h6>
            </Column>
        </Row>
               <Row>
                    <Column lg={12} className="p-10">
                                {customerActivities.map((activity, index) => (
                                    <React.Fragment key={activity.id}>
                                        <div className="card activity-history-container">
                                            <div className="header">
                                                <span className="policy-type">{activity.activityType}</span>
                                                <span className="policy-date-time">{new Date(activity.activityEffDate).toLocaleDateString('en-US', dateOptions)} at {new Date(activity.activityEffDate).toLocaleTimeString('en-US', timeOptions)}</span>
                                            </div>
                                            <div>
                                                 {activity.description && activity.description.length > charLength ? (
                                    expandedActivities[activity.id] ? (
                                        <>
                                            {activity.description}{' '}
                                            <span 
                                                className="more-less-toggle"
                                                onClick={() => toggleExpanded(activity.id)}
                                            >
                                                LESS
                                            </span>
                                        </>
                                    ) : (
                                        <>
                                            {activity.description.substring(0, charLength)}{'... '}
                                            <span 
                                                className="more-less-toggle"
                                                onClick={() => toggleExpanded(activity.id)}
                                            >
                                                MORE
                                            </span>
                                        </>
                                    )
                                ) : (
                                    activity.description
                                )}
                                            </div>
                                        </div>
                                      
                                    </React.Fragment>
                                ))}
                        {loadMoreButton == true ? (<Button style={{ marginBottom: '1rem' }} onClick={loadMoreActivities}>Load More</Button>) : ""}
                    </Column>
                </Row>
        

    </>;

    return <div className="slider-tab-content-main-div">
        {mainContennt}
    </div>;
}


const SliderActivityHistory = forwardRef(SliderActivityHistoryInner);
export default SliderActivityHistory;
export { SliderActivityHistoryInner };